<template>
  <PageLoader v-if="isLoading" />
  <div class="w-100 py-5 px-10">
    <div style="height: 100%!important; width: 100%" class="scroll-container">
      <div id="kt_docs_jkanban_rich"></div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref, shallowRef, computed, defineProps, watch, onBeforeMount} from "vue";
import {$formatLocalAmount, convertSeconds, subText} from "@/mixins/Helpers";
import i18n from "@/plugins/i18n";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {Theme} from "@/composables/theming";
import PageLoader from "@/components/PageLoader.vue";
import { useInitialName } from "@/composables/InitialName";
import {useHasAbility} from "@/composables/hasAbility";
import abilities from "@/composables/abilities";

const store = useStore()
const router = useRouter()
const {initial} = useInitialName() 
const { can } = useHasAbility()

const props = defineProps({
  filter: {
    type: Object,
    default: () => ({
      startDate: '',
      endDate: '',
      status: '',
      contact: '',
      search: '',
      seller: '',
      priority: ''
    })
  }
})

const isLoading = ref(true)
const kanban = shallowRef(null)
const pipelines = shallowRef([])

const defaultCurrency = computed(() => store.getters["company/getCompanyCurrency"])
const contacts = computed(() => store.getters["contacts/getContacts"])
const users = computed(() => store.getters["user/getUsers"])

watch(() => props.filter, (value) => {
  if (!isLoading.value) {
    loadPipelineByState(true)
  }
}, {deep: true})

window.toggleForm = function toggleForm(pipelineId) {
  const form = document.getElementById(`form-${pipelineId}`);
  form.style.display = form.style.display === 'none' ? 'block' : 'none';
  document.getElementById(`opportunity-${pipelineId}`).value = ''
  document.getElementById(`amount-${pipelineId}`).value = 0
  document.getElementById(`customer-${pipelineId}`).value = ''
  initSelect2(pipelineId)
}

window.closeForm = function closeForm(pipelineId) {
  const form = document.getElementById(`form-${pipelineId}`);
  form.style.display = 'none';
}

window.goToEdit = function goToEdit(id) {
  if(can(abilities.UPDATE_OPPORTUNITIES)) {
    router.push({ name: 'pipelines-view', params: { id: id } })
  }
}

window.goToContactFiche = function goToContactFiche(id) {
  if(id) {
    router.push({ name: 'contact-view-path', params: {id} })
  }
}

const destroyKanban = () => {
  const kanbanElement = document.getElementById('kt_docs_jkanban_rich');
  if (kanbanElement) {
    kanbanElement.innerHTML = '';
    kanban.value = ''
  }
};

function jkanbanInit() {
  "use strict";

  destroyKanban()

  if (!kanban.value) {
    let KTJKanbanDemoRich = function () {
      let boards = [];
      pipelines.value.forEach((pipeline, index) => {
        let items = [];
        items = pipeline?.opportunities?.map((pipelineItem, index) => {
          return pipelineStepItem(pipeline.id,pipeline?.criterias?.length , pipelineItem);
        });

        boards.push(
            pipelineStep(pipeline.id, pipeline.name, pipeline.opportunities_sum_expected_income || 0, items, index)
        );
      });

      let exampleRich = function () {


        kanban.value = new jKanban({
          element: '#kt_docs_jkanban_rich',
          gutter: '0',
          widthBoard: '325px',
          click: function (el) {
            let elementId = el.dataset.eid;
            //router.push({name: 'pipelines-view', params: {id: elementId}})
          },
          dragendEl: changeOpportunityState,
          dragendBoard: changeOpportunityStepPosition,
          dragBoard: (el, source) => {},
          boards: boards
        });

      }



      return {
        init: function () {
          exampleRich();
          const forms = document.querySelectorAll('.pipelineStepItemForm')
          let clickedButton = null
          forms.forEach(form => {
            const buttons = form.querySelectorAll('button[type="submit"]');

            buttons.forEach(button => {
              button.addEventListener('click', (e) => {
                clickedButton = e.target;
              });
            });

            form.addEventListener('submit', (e) => {
              e.preventDefault();
              if (clickedButton) {
                submitForm(clickedButton.getAttribute('data-board-id'), clickedButton.getAttribute('data-edit') || null);
              }
            });

          })
        }
      };
    }();

    KTUtil.onDOMContentLoaded(function () {
      KTJKanbanDemoRich.init();
    });
  }
}

function pipelineStep(boardId, boardName, amount = 0, items = [], index) {
  return ({
    id: boardId,
    title: `
      <div>
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="card-title d-flex w-75">
              <span>${boardName}</span>
              <span id="board-${boardId}-count" class="badge badge-warning rounded-4 w-30px ms-3 d-flex justify-content-center"> ${items.length} </span>
            </h3>
            <div>
              ${
                  can(abilities.CREATE_OPPORTUNITIES)
                      ? `<i onClick="toggleForm('${boardId}')" class="fa fa-plus text-dark fs-4"></i>`
                      : ''
              }
            </div>
          </div>
          <div class="d-flex mt-2 mb-3">
            <span id="board-${boardId}-amount" class="small ms-auto fw-bold">${$formatLocalAmount(amount) + ' ' + defaultCurrency.value?.symbol} </span>
          </div>
          <div class="row g-2">
          ${getStepBar(index)}
          </div>
         <div class="mt-4">
            ${pipelineStepItemForm(boardId)}
        </div>
      </div>
    `,
    class: 'align-items-stretch',
    item: items
  })
}

function pipelineStepItemForm(boardId) {

  return `<div class="card my-1 p-3" style="display: none" id="form-${boardId}" >
            <form id="forme-${boardId}" class="pipelineStepItemForm">
              <div class="d-flex flex-column mb-2 fv-row col-12 col-md-12 mt-auto mb-2">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span class="required">${i18n.global.t('crm.pipeline.label.opportunity')}</span>
                  </label>
                  <input type="text" id="opportunity-${boardId}" class="form-control form-control-sm form-control-solid" required />
              </div>
              <div class="form-group col-12 col-md-12 mt-auto mb-2">
                  <label class="fs-6 fw-bold required">${i18n.global.t('crm.pipeline.label.opportunityContact')}</label>
                 <div>
                  <select required id="customer-${boardId}" name="pipelines-contact-${boardId}" data-control="select2" class="form-select form-control-sm form-select-solid kt_select2">
                      ${createContactOptionRow()}
                  </select>
                 </div>
              </div>
              <div class="d-flex flex-column mb-8 fv-row col-12 col-md-12 mt-auto mb-2">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span class="required">${i18n.global.t('crm.pipeline.label.opportunityExpectedAmount')} (${defaultCurrency.value?.iso}) </span> 
                  </label>
                  <input type="text" id="amount-${boardId}" class="form-control form-control-sm form-control-solid" min="1" required placeholder="0" />
              </div>
              <div class="d-flex">
                <button type="button" onclick="closeForm('${boardId}')" style="border-radius: 5px; color: #646E7B; background-color: #E6E7E9" class="btn btn-sm shadow h-30px d-flex align-items-center justify-content-center">
                  ${i18n.global.t('button.cancel')}
                </button>
                ${
                    can(abilities.UPDATE_OPPORTUNITIES)
                      ? `
                        <button type="submit" data-board-id="${boardId}" data-edit="${true}" style="border-radius: 5px;"
                        class="btn btn-sm btn-primary shadow h-30px d-flex align-items-center justify-content-center ms-auto me-2 edit">
                          <span class="spinner-border spinner-border-sm d-none" role="status"
                                      aria-hidden="true"></span>
                          ${i18n.global.t('button.edit')}
                        </button>
                        `
                      : ''
                }

                <button  type="submit" data-board-id="${boardId}" data-edit="" style="border-radius: 5px;"
                        class="btn btn-sm btn-primary shadow h-30px d-flex align-items-center justify-content-center add">
                  <span class="spinner-border spinner-border-sm d-none" role="status"
                              aria-hidden="true"></span>
                  ${i18n.global.t('button.add')}
                </button>
              </div>
            </form>
          </div>`
}

function createContactOptionRow() {
  let options = ''
  for (let contact of contacts.value) {
    options += `<option value="${contact.id}"> ${contact.fullname} </option>`
  }
  return options
}

function pipelineStepItem(boardId,criteriasCount, opportunity = {}) {
  let initialName = ''
  if(opportunity.creator_id) {
    let user = users.value.filter(user => user.id == opportunity.creator_id)[0]

    const [firstname, lastname] = user.fullname.toUpperCase().split(' ')
    initialName += firstname[0]
    if(lastname) {
      initialName += lastname[0]
    }
  }

  const feeling = opportunity?.feeling || ''
  const checkedCount = opportunity?.criterias?.filter(item => item.checked)?.length || 0;


  const data = JSON.stringify({
    id: opportunity?.id,
    step: boardId,
    criterias: opportunity?.criterias
  }).replace(/"/g, '&quot;')
    .replace(/\\/g, '\\\\')  
    .replace(/"/g, '&quot;') 
    .replace(/'/g, "\\'")    
    .replace(/\n/g, '\\n')   
    .replace(/\r/g, '\\r');


    const criteriasHTML = opportunity?.criterias?.length > 0
    ? `
    <div class="" id="crittary_accordion_${opportunity.id}">
        <div class="accordion-item border-0">
            <div class="accordion-header" id="crittary_accordion_${opportunity.id}_header">
              <div class="d-flex align-items-center justify-content-between"
                style="cursor: pointer !important;"
                data-bs-toggle="collapse"
                 data-bs-target="#crittary_accordion_${opportunity.id}_body" aria-expanded="true" aria-controls="crittary_accordion_${opportunity.id}_body"
                >
                <span class="small text-primary fw-bold">
                  <i class="bi bi-check-square-fill me-2 text-primary fw-bold"></i>
                  ${i18n.global.t('crm.pipeline.label.criterias')}
                </span>
                <span id="op_criterias_check_count_${opportunity.id}"> ${checkedCount + '/' + criteriasCount} </span>
              </div>
            </div>
            <div id="crittary_accordion_${opportunity.id}_body" class="accordion-collapse collapse" aria-labelledby="crittary_accordion_${opportunity.id}_header" data-bs-parent="#crittary_accordion_${opportunity.id}">
              <div class="accordion-body p-0">
                 <hr class="hr my-3"/>
                 ${generateCriteriasCheckBox(opportunity?.criterias, opportunity.id)}
              </div>
            </div>
        </div>
    </div>

    `
    : '';

  return ({
    id: opportunity.id,
    parent: boardId,
    title: `
     <div data-id="${opportunity.id}" data-step="${boardId}" data-criterias='${JSON.stringify(opportunity?.criterias)}' class="card mb-2" style="${opportunity.status == 'LOST' ? 'border-left: 6px solid #F71C3F;' : opportunity.status == 'WON' ? 'border-left: 6px solid #2DA333;' : ''}">
        <div class="p-4">
          <div onclick="event.stopPropagation(); goToEdit('${opportunity.id}')" class="d-flex align-items-center justify-content-between">
            <h6 onclick="event.stopPropagation(); goToEdit('${opportunity.id}')" class="op-title"> ${subText(opportunity.name, 30)} </h6>
            <div>
              <div class="position-relative d-inline-block">
                <div class="symbol-group symbol-hover">
                  <div class="symbol symbol-circle symbol-30px">
                    <div class="symbol-label fs-5 fw-semibold bg-inverse-primary text-primary">
                      ${initialName}
                    </div>
                  </div>
                  ${opportunity.followers && opportunity.followers_count <= 2 ? 
                    opportunity.followers.map(collaborator => `
                      <div class="symbol symbol-circle symbol-30px">
                        <div class="symbol-label fs-5 fw-semibold bg-inverse-primary text-primary">
                          ${initial(collaborator.fullname)}
                        </div>
                      </div>
                    `).join('') : ''}

                  ${opportunity.followers && opportunity.followers_count > 2 ? `
                    <span class="badge bg-primary text-white position-absolute top-2 start-100 translate-middle p-1 badge-circle" style="font-size: 12px;">
                      ${opportunity.followers_count}
                    </span>` : ''}
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between my-2">
            <div>
              <span onclick="event.stopPropagation(); goToContactFiche('${opportunity.contact_id}')"  style="cursor: pointer !important;"> ${opportunity.contact?.fullname} </span> <span class="ms-2"> ${ feeling } </span>
            </div>
            <div class="rating">
              ${displayOpportunityPriority(parseInt(opportunity.priority))}
            </div>

          </div>
          <div class="d-flex align-items-center justify-content-between">
            <span class="small text-primary fw-bold">
              <i class="bi bi-clock-fill me-2 text-primary fw-bold"></i>
              ${convertSeconds(opportunity.state_date_formatted) || ''}
            </span>
            <span> ${$formatLocalAmount(opportunity.expected_income) + ' ' + defaultCurrency.value?.symbol} </span>
          </div>
          ${criteriasHTML}
        </div>
      </div>
            `,
  })
}

function initSelect2(id) {
  const select = $("#customer-" + id)
  select.select2()
  const amountInput = $("#amount-" + id)
  if (amountInput.length > 0) {
    amountInput.on('input', (e) => {
      let value = String(e.target.value).replace(/[^0-9,-]+/g, "");
      e.target.value = value ? $formatLocalAmount(value) : '';
    });

    amountInput.on('focus', (e) => {
      let value = String(e.target.value).replace(/[^0-9,-]+/g, "");
      e.target.value = value ? $formatLocalAmount(value) : '';
    });

    amountInput.on('blur', (e) => {
      let value = String(e.target.value).replace(/[^0-9,-]+/g, "");
      e.target.value = value ? $formatLocalAmount(value) : '';
    });
  }

}

function getStepBar(currentStep = 1, stepsNumber = 6, activeColor = Theme.blue) {
  let stepBar = ``
  for (let i = 0; i <= stepsNumber; i++) {
    stepBar += `
      <div class="col">
        <div class="progress" style="height: 5px!important;" role="progressbar" aria-label="Example high" aria-valuemin="0" aria-valuemax="100">
          <div
              class="progress-bar ${i <= currentStep ? 'w-100' : 'w-0'}"
              style="background-color: ${i <= currentStep ? activeColor + '!important' : ''}; height: '5px' ">
          </div>
        </div>
      </div>
     `
  }
  return stepBar
}

function displayOpportunityPriority(priority = 0) {
  let rating = ''
  for (let i = 1; i <=3; i++) {
    rating += `<div class="rating-label ${priority >= i ? 'checked' : ''}">
                  <i class="fa fa-star fs-7"></i>
              </div>`
  }
  return rating;
}

function updateBoards() {
  pipelines.value.forEach(pipeline => {
    const boardAmountSpan = $(`#board-${pipeline.id}-amount`)
    const newText = ($formatLocalAmount(pipeline.opportunities_sum_expected_income) || 0) + ' ' + defaultCurrency.value?.symbol
    boardAmountSpan.text(newText)
    const boardElementCount = $(`#board-${pipeline.id}-count`)
    boardElementCount.text(pipeline.opportunities.length)
  });

}

function updateBoardElement() {
  if (kanban.value) {

    pipelines.value.forEach((pipeline) => {
      if(pipeline){
        const boardElements = kanban.value.getBoardElements(pipeline?.id)
        while (boardElements.length) {
          kanban.value.removeElement(boardElements[0]?.dataset.eid)
        }
        pipeline?.opportunities?.forEach((pipelineItem, index) => {
          const boardItemData = pipelineStepItem(pipeline.id,pipeline?.criterias?.length, pipelineItem);
          kanban.value.addElement(pipeline.id, boardItemData, 0);
        });

      }
    })

  }
}

async function loadPipelineByState(isUpdate = false) {
  try {
    isLoading.value = true
    let {data: pipelinesByStates} = await store.dispatch('pipelines/loadPipelinesByStates', props.filter)
    pipelines.value = pipelinesByStates.data
    if (isUpdate) {
      updateBoardElement()
      updateBoards()
    }
  }catch (e) {

  }finally {
    isLoading.value = false 
  }
}

function generateCriteriasCheckBox(options = [], id) {
  let checkboxes = '';
  options.forEach((option) => {
    if(option.checked) {
      checkboxes += `
      <div class="mb-2">
        <i id="${option.id.toString().trim()}" onclick="event.stopPropagation(); setCriteriaStatus('${id}', '${option.id}')" class="cursor-pointer fs-2 bi bi-check-square-fill text-primary checked"></i>
        <label onclick="event.stopPropagation(); setCriteriaStatus('${id}', '${option.id}')" for="${option.id}" class="form-check-label fs-6 fw-bolder text-black cursor-pointer">
          ${option.title}
        </label>
      </div>
    `;
    } else {
      checkboxes += `
      <div class="mb-2">
        <i id="${option.id.toString().trim()}" onclick="event.stopPropagation(); setCriteriaStatus('${id}', '${option.id}')" class="cursor-pointer fs-2 bi bi-square"></i>
        <label onclick="event.stopPropagation(); setCriteriaStatus('${id}', '${option.id}')" for="${option.id}" class="form-check-label fs-6 fw-bolder text-black cursor-pointer">
          ${option.title}
        </label>
      </div>
    `;
    }

  });

  return checkboxes;
}

window.setCriteriaStatus = function setCriteriaStatus(id, value) {
  store.dispatch('pipelines/changeOpportunityStateByCriterias', {
    opportunity_id: id,
    criterias: [value],
  })
      .then((res) => {
        const checkedClasses = ['bi-check-square-fill', 'text-primary', 'checked'];
        const notCheckedClasses = ['bi-square'];

        const checkbox = document.getElementById(value.toString().trim());
        if (!checkbox) return;

        const isChecked = checkbox.classList.contains('checked');
        const counter = document.getElementById('op_criterias_check_count_' + id)
        const [count, total] = counter.textContent.toString().split('/')
        if (isChecked) {
          checkbox.classList.remove(...checkedClasses);
          checkbox.classList.add(...notCheckedClasses);
          counter.innerText = `${parseInt(count) - 1 + '/' + total}`
        } else {
          checkbox.classList.remove(...notCheckedClasses);
          checkbox.classList.add(...checkedClasses);
          counter.innerText = `${parseInt(count) + 1 + '/' + total}`
        }
      })
      .catch((err) => {
        console.error('Error updating criteria', err);
      });
}

function changeOpportunityState(el) {
  const target = el.offsetParent.dataset.id
  const source = el.dataset.eid
  const opportunityId = el.children[0].dataset.id
  const data = {
    id: opportunityId,
    opportunity_id: opportunityId,
    opportunity_state_id: target,
  }
  store.dispatch('pipelines/changeOpportunityState', data)
      .then(res => {
        loadPipelineByState(props.filter, true)
      })
      .catch((err) => {
        window.toastr['error'](err.response.data.message || err.message)
      })
}

function changeOpportunityStepPosition(el){
  const boardId = el.dataset.id
  const newOrder = el.dataset.order

  let form = {
    opportunityState: boardId,
    new_order: newOrder
  }

  store.dispatch('steps/updateStepOrder', form)
      .then((response) => {
        loadPipelineByState(true)
      })
      .catch((err) => {
        window.toastr['error'](err.response.data.message || err.message)
      })
}

function submitForm(pipelineId, isEdit = '') {

  const submitBtnLoader = isEdit
      ? document.querySelector(`#form-${pipelineId} button.edit span`)
      : document.querySelector(`#form-${pipelineId} button.add span`);
  submitBtnLoader.classList.remove('d-none')
  submitBtnLoader.classList.add('disable')
  const value = String(document.getElementById(`amount-${pipelineId}`).value).replace(/[^0-9,-]+/g, "");
  const data = {
    name: document.getElementById(`opportunity-${pipelineId}`).value,
    expected_income: parseFloat(value),
    contact_id: document.getElementById(`customer-${pipelineId}`).value,
    opportunity_state_id: pipelineId
  }

  store.dispatch('pipelines/createPipelineSimple', data)
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.pipeline_created"))
        if (isEdit) {
          router.push({name: 'pipelines-view', params: {id: res?.data?.data?.id}})
        }
        loadPipelineByState(true)
        closeForm(pipelineId);
      })
      .catch((err) => {
      })
      .finally(() => {
        submitBtnLoader.classList.add('d-none')
        submitBtnLoader.classList.remove('disable')
      })
}

function loadData() {
  Promise.all([
    loadPipelineByState(),
    store.dispatch('company/generalInformation'),
    store.dispatch('contacts/loadContacts'),
    store.dispatch('user/loadUsers')
  ]).finally(() => {
    isLoading.value = false
    jkanbanInit()
  })
}

onBeforeMount(() => {
  const script = document.createElement('script');
  script.src = '/assets/plugins/custom/jkanban/jkanban.bundle.js';
  script.async = false;
  document.head.appendChild(script);

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = '/assets/plugins/custom/jkanban/jkanban.bundle.css';
  link.type = 'text/css'
  document.head.appendChild(link);
})


onMounted(() => {
  loadData()
})
</script>

<style scoped>


.kanban-item {
  padding: 0 !important;
}

.op-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 100%;
  white-space: nowrap;
  padding: 10px;
  transform: rotateX(180deg);
}

.scroll-container > * {
  transform: rotateX(180deg);
}

</style>


